import cNavi from './cNavi.vue';

export default {
  install(Vue) {
    Vue.component('cNavi', cNavi);
  },
};
